import axios from "./index.service";

export default class FeeService {
  static createFee(payload) {
    console.log({ payload });
    return axios({
      method: "POST",
      url: `/api/services/v1/fees/`,
      data: payload,
    });
  }

  static fetchAllFees() {
    return axios({
      method: "GET",
      url: `/api/services/v1/fees/`,
    });
  }

  static fetchByType(fee_type) {
    return axios({
      method: "GET",
      url: `/api/services/v1/fees/type/${fee_type}`,
    });
  }

  static approveOrDisapprove(payload) {
    const { id, action } = payload;
    const apiAction = action === "approve" ? "activate" : "deactivate";
    return axios({
      method: "PUT",
      url: `/api/services/v1/fees/${apiAction}/${id}`,
    });
  }

  static delete(id) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/fees/${id}`,
    });
  }

  static update(id, payload) {
    return axios({
      method: "PUT",
      url: `/api/services/v1/fees/${id}`,
      data: payload,
    });
  }

  static getUserOutstandingAlumniFee() {
    return axios({
      method: "GET",
      url: `/api/services/v1/fees/outstanding-alumni-fee`,
    });
  }
}
